import { memo, FunctionComponent } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useTimer } from '~components/hooks';

interface WheelTimerProps {
  lastWheelGame: Date;
}

const WheelTimer: FunctionComponent<WheelTimerProps> = ({ lastWheelGame }) => {
  const nextGameTime = dayjs(lastWheelGame).add(24, 'hours').toDate();
  const eventTimer = useTimer(nextGameTime);

  const { t } = useTranslation();

  return (
    eventTimer && (
      <div className="circle-controls-timer">
        <div className="circle-timer-days">
          <span>0</span> {t('day_plural')}
        </div>
        <div className="circle-clock">
          <div className="circle-clock-hours">{eventTimer?.hours}</div>
          <span>:</span>
          <div className="circle-clock-min">{eventTimer?.minutes}</div>
          <span>:</span>
          <div className="circle-clock-sec">{eventTimer?.seconds}</div>
        </div>
      </div>
    )
  );
};

export default memo(WheelTimer);
